<template>
  <FullLayout />
</template>

<script setup lang="ts">
import FullLayout from './full/FullLayout.vue'
</script>
